import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  unknownModal: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
